/**
 * Display labels for AI discovery signal sources (the backend's AiSignalSources codes). The one
 * map for every surface that shows a source — the dashboard and the Behavior 360 panel both read
 * it, so the same source never reads differently on two tabs.
 *
 * CONSTRUCTED is the constructed-estate fixture source. It is labelled, never hidden: wherever it
 * surfaces it says what it is.
 */

const SIGNAL_SOURCE_LABEL = {
  ENTRA_AGENT: "Entra Agent ID",
  GRAPH_SP: "Microsoft Graph",
  AZURE_RESOURCE_GRAPH: "Azure Resource Graph",
  GITHUB: "GitHub",
  GITLAB: "GitLab",
  AZURE_DEVOPS: "Azure DevOps",
  AWS: "AWS",
  GCP: "Google Cloud",
  GCP_IAM: "Google Cloud IAM",
  OPENAI: "OpenAI Admin API",
  ANTHROPIC: "Anthropic Admin API",
  COPILOT_STUDIO: "Copilot Studio",
  LOCAL_AGENT: "Local agent (Defender for Endpoint)",
  DEFENDER_XDR: "Microsoft Defender (data-leak alert)",
  GRAPH_ACTIVITY: "Microsoft Graph activity logs",
  CONSTRUCTED: "Constructed reference data",
};

/** The display label for a source code; an unknown code passes through raw rather than vanishing. */
export const signalSourceLabel = (code) =>
  (Object.prototype.hasOwnProperty.call(SIGNAL_SOURCE_LABEL, code) && SIGNAL_SOURCE_LABEL[code]) || code;
